import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MultipleFilterProperty } from '../../_model/multiple-filter-property';
import { TableFilters } from '../../_model/table-response/table-filters';
import { DatePipe } from '@angular/common';
import { Constants } from '../../_model/constants';
import { ExportService } from '../../service/export.service';
import { Subscription } from 'rxjs';
import { ClientStateService } from '../navbar/client-state.service';
import { LoginStateService } from "../../pages/login/login-state.service";
import { SnackbarService } from '../../service/snackbar.service';
import { environment } from '../../../environments/environment';
import { UserService } from '../../service/user.service';
import { User } from '../../_model/user/user';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-customer-mapping-multiple-input-filter',
    templateUrl: './customer-mapping-multiple-input-filter.component.html',
    standalone: true,
    imports: [
        MatChipsModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatOptionModule,
        MatFormFieldModule,
        MatSelectModule,
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule
    ],
    styleUrls: ['./customer-mapping-multiple-input-filter.component.scss']
})


export class CustomerMappingMultipleInputFilterComponent implements OnInit {

    @Input() tableFilters!: TableFilters[];
    @Output() selectedFilter = new EventEmitter<FormGroup>();

    clientSubscription!: Subscription;

    localTableFilters!: TableFilters[];
    filterForms!: FormGroup;
    todayDate!: Date;


    filterArray: Array<MultipleFilterProperty> = [];
    dateFilterSelected = false;
    filterApplied = false;
    removable = true;
    filterAdded = false;
    dateFilterAdded = false;
    excelClicked = false;
    isAddCliecked = false;
    searchClicked = false;
    isLoadingResults = false;
    isVisits = false;
    selected: any;
    filterArrayForms!: FormGroup;
    visitFlag = false;
    workOrderFlag = false;
    start_date: any;
    end_date: any;
    us = false;
    europe = false;
    asia = false;
    workOrders: string[] = [
        'CORRECTIVE',
        'MAINTENANCE'
    ];
    workOrdersUk: string[] = [
        'JOBS',
        'MAINTENANCE',
        'CALL OUT',
        'FOLLOW-UP',
        'RECOMMENDATION',
        'NO-ACTION',
        'FIELD BIOLOGIST'
    ];
    mappedTo: string[] = [
        'SiteName',
        'PremisePurchaseOrderNo'
    ];
    constructor(private fb: FormBuilder,
        public datepipe: DatePipe,
        private exportService: ExportService, private userService: UserService,
        private clientStateService: ClientStateService, private loginStateService: LoginStateService, private sbService: SnackbarService) {
        this.initializeFilter();
    }

    ngOnInit() {
        if (environment.region === 'US') {
            this.us = true;
        }
        if (environment.region === 'EUROPE') {
            this.europe = true;
        }
        if (environment.region === 'ASIA') {
            this.asia = true;
        }
        this.localTableFilters = this.tableFilters;
        this.clientSubscription = this.clientStateService.clientStateChanged$.subscribe(() => {
            this.initializeFilter();
            this.filterApplied = false;
            this.dateFilterSelected = false;
            this.filterAdded = false;
            this.dateFilterAdded = false;
            this.visitFlag = false;
            this.workOrderFlag = false;
            this.filterArray = [];
        });
        if (this.loginStateService.isVisits == true) {
            // this.visitFilter();
            this.visitFlag = true;
            this.loginStateService.isVisits = false;
        }
        else if (this.loginStateService.isWorkOrders == true) {
            this.workOrderFlag = true;
            this.loginStateService.isWorkOrders = false;
        }
        else {
            this.visitFlag = false;
            this.workOrderFlag = false;
            this.loginStateService.isVisits = false;
            this.loginStateService.isWorkOrders = false;
            this.removeItem();
        }
    }


    removeItem() {
        // JSON.parse(localStorage.getItem('setFilter')) || 
        if (this.visitFlag) {
            // localStorage.removeItem('setFilter');
            this.loginStateService.isVisits = false;
            this.visitFlag = false;
        }
        else if (this.workOrderFlag) {
            this.loginStateService.isWorkOrders = false;
            this.workOrderFlag = false;
        }
    }
    // visitFilter() {

    // const filter = JSON.parse(localStorage.getItem('setFilter'));
    // const filter = JSON.parse(localStorage.getItem('setSelectedFilter'));
    // this.visitFlag = true;
    // console.log("visitfilter fn",this.loginStateService.isVisits,this.visitFlag)

    // this.filterForms = this.fb.group({
    //   tableFilter: filter.tableFilter,
    //   value: filter.value,
    //   valuedate: filter.valuedate,
    //   multipleFilterarray: filter.multipleFilterarray
    // });
    // }


    checkAndCallMethods() {
        if (this.isAddCliecked) {
            this.addFilter();
        } else if (this.searchClicked) {
            if (this.filterArray.length > 0) {
                const multipleFilterControl = this.filterForms.get('multipleFilterarray');
                // Add a null check before calling setValue()
                if (multipleFilterControl) {
                    multipleFilterControl.setValue(this.filterArray);
                }
            }
            this.selectedFilter.emit(this.filterForms);
            //this.initializeFilter();
        } else if (this.excelClicked) {
            if (this.filterArray.length > 0) {
                const multipleFilterControl = this.filterForms.get('multipleFilterarray');
                // Add a null check before calling setValue()
                if (multipleFilterControl) {
                    multipleFilterControl.setValue(this.filterArray);
                }
            }
            this.getDatatoExcel(this.filterForms);
        }
    }

    addFilter() {
        let multipleFilterProperty = new MultipleFilterProperty();
        let isDuplicate = false;
        for (let item of this.filterArray) {

            if (item.value === this.filterForms.value.value) {
                isDuplicate = true;
                break;
            }
        }
        let existItem = this.filterArray.filter(item => item.dispalyName === this.filterForms.value.tableFilter.displayName);
        if (!isDuplicate && (existItem.length < 1 || (existItem.length >= 0 && this.filterForms.value.tableFilter.displayName == Constants.status))) {
            if (this.filterForms.value.tableFilter.displayName == Constants.date) {
                let existDateItem = this.filterArray.filter(item => item.dateValue === this.filterForms.value.tableFilter.displayName);
                if (existDateItem.length < 1) {
                    multipleFilterProperty.dispalyName = this.filterForms.value.tableFilter.displayName;
                    multipleFilterProperty.column = this.filterForms.value.tableFilter.column;
                    multipleFilterProperty.dateValue = this.filterForms.value.tableFilter.displayName;
                    multipleFilterProperty.dateBackendName = this.filterForms.value.value
                    multipleFilterProperty.origionalStartDateFormat = this.filterForms.value.valuedate.begin;
                    multipleFilterProperty.origionalEndDateFormat = this.filterForms.value.valuedate.end;
                    if (environment.locale == "en-GB") {
                        this.start_date = this.datepipe.transform(this.filterForms.value.valuedate.begin, Constants.dateFormatEngb);
                        this.end_date = this.datepipe.transform(this.filterForms.value.valuedate.end, Constants.dateFormatEngb);
                    }
                    else if (environment.locale == "en-US") {
                        this.start_date = this.datepipe.transform(this.filterForms.value.valuedate.begin, Constants.dateFormaten029);
                        this.end_date = this.datepipe.transform(this.filterForms.value.valuedate.end, Constants.dateFormaten029);
                    }
                    multipleFilterProperty.value = this.start_date + " - " + this.end_date;
                    this.filterArray.push(multipleFilterProperty);
                    this.dateFilterAdded = true;
                } else {
                    alert(Constants.dateErrorAlert);
                }

            } else {
                multipleFilterProperty.dispalyName = this.filterForms.value.tableFilter.displayName;
                multipleFilterProperty.column = this.filterForms.value.tableFilter.column;
                multipleFilterProperty.value = this.filterForms.value.value;
                this.filterArray.push(multipleFilterProperty);
            }
        } else {
            alert(Constants.duplicateFilterAlert);
        }
        this.filterApplied = true;
        this.initializeFilter();
        this.dateFilterSelected = false;
        this.filterAdded = true;
    }


    changeValue(filter: any) {
        this.filterForms.get('value')?.reset('');
        this.filterForms.get('valuedate')?.reset({ start: '', end: '' });
        if ((filter?.displayName === 'Date' || filter?.displayName === Constants.date) && filter?.values?.length === 1) {
            this.filterForms.get('value')?.setValue(filter.values[0]);
        }
        if (this.filterForms.value.tableFilter.displayName == Constants.date) {
            if (filter.displayName == Constants.scheduledStartDate) {
                this.todayDate = new Date(Constants.scheduledStartActiveDate);
            } else {
                this.todayDate = new Date("");
            }
            this.dateFilterSelected = true;
        } else {
            this.dateFilterSelected = false;
        }
    }

    private initializeFilter() {
        this.filterForms = this.fb.group({
            tableFilter: '',
            value: '',
            valuedate: '',
            multipleFilterarray: []
        });
    }

    remove(value: string): void {
        const index = this.filterArray.map(e => e.value).indexOf(value);
        if (index >= 0) {
            this.filterArray.splice(index, 1);
        }

        const dateIndex = this.filterArray.map(e => e.dateValue).indexOf(Constants.date);
        if (dateIndex <= -1) {
            this.dateFilterAdded = false;
        }

        if (this.filterArray.length == 0) {
            this.filterAdded = false;
            this.selectedFilter.emit(this.filterForms);
        }
    }

    isArray = () => ((this.filterForms.value.multipleFilterarray != null && this.filterForms.value.multipleFilterarray.length >= 1));
    // isArray = () => this.filterForms.value.tableFilter.values && this.filterForms.value.tableFilter.values.length;
    isFilterSet = () => (!(this.filterForms.value.tableFilter.displayName != Constants.dispalyNameWoNumber && this.filterForms.value.value) ||
        !(this.filterForms.value.tableFilter.displayName != Constants.displayNameWoId && this.filterForms.value.value));

    isWONumberFilterApplied = () => {

        if ((this.filterForms.value.tableFilter.displayName == Constants.dispalyNameWoNumber ||
            this.filterForms.value.tableFilter.displayName == Constants.displayNameWoId) && this.filterForms.value.value) {
            return true;
        } else if (this.dateFilterAdded) {
            return true;
        } else {
            return false;
        }
    };

    isAnyFilterSet = () => {
        if (this.filterArray.length >= 1) {
            return true;
        }
        else {
            return false;
        }
    }

    isExcelClicked() {
        this.excelClicked = true;
        this.searchClicked = false;
        this.isAddCliecked = false;
    }

    isSearchClicked() {
        this.searchClicked = true;
        this.excelClicked = false;
        this.isAddCliecked = false;
    }

    isAddFilterCliecked() {
        this.isAddCliecked = true;
        this.checkAndCallMethods();
    }

    reset() {
        this.initializeFilter();
        this.selectedFilter.emit(this.filterForms);
        this.filterApplied = false;
        this.dateFilterSelected = false;
        this.filterAdded = false;
        this.dateFilterAdded = false;
        this.filterArray = [];
        this.removeItem();
    }

    private getDatatoExcel(formValues: FormGroup) {
        this.isLoadingResults = true;
        let user: User = this.userService.getUser();
        this.exportService.getDataToExcel(formValues, user.brand).subscribe(response => {
            if (response.data !== null) {
                this.isLoadingResults = false;
                window.open(response.data, "_blank");
            }
            else {
                this.isLoadingResults = false;
                // alert(response.message);
                this.sbService.openSnackBar(response.message, 'Close');
            }

            (error: any) => {
                this.sbService.openSnackBar(error, 'Close');
                this.isLoadingResults = true
            }
        })
    }

}
